import apiService from "@/services/shared/http/apiService"

export default class CrudService {
    endPoint = null
    api = new apiService()

    constructor(endPoint) {
        this.endPoint = endPoint
    }

    index(params = {}) {
        return this.api.GET(this.endPoint, params)
    }

    show(id, params = {}) {
        return this.api.GET(this.endPoint + '/' + id, params)
    }

    update(id, data, params = {}) {
        return this.api.PUT(this.endPoint + '/' + id, data, params)
    }

    create(data, params = {}) {
        return this.api.POST(this.endPoint, data, params)
    }

    delete(id, params = {}) {
        return this.api.DELETE(this.endPoint + '/' + id, params)
    }
}
